// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetButton_root__1IgSa","resetZoomButton":"ResetButton_resetZoomButton___TD1v"};